// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Select Container */
.select-container {
    position: relative;
    width: 280px;
}

.select-full-width {
    width: 100%;
}

.select-disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Select Trigger */
.select-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    padding: 0 12px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.select-outlined {
    border: 1px solid #d1d5db;
    background-color: white;
}

.select-outlined:hover {
    border-color: #9ca3af;
}

.select-filled {
    background-color: #f3f4f6;
}

.select-filled:hover {
    background-color: #e5e7eb;
}

.select-standard {
    border-bottom: 1px solid #d1d5db;
    background-color: transparent;
}

.select-standard:hover {
    border-color: #9ca3af;
}

.select-error {
    border-color: #ef4444 !important;
}

.select-trigger-disabled {
    cursor: not-allowed;
}

/* Select Value and Placeholder */
.select-value {
    flex: 1 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    font-weight: 400;
    color: #344767;
}

.select-placeholder {
    color: #6b7280;
}

/* Select Actions */
.select-actions {
    display: flex;
    align-items: center;
}

.select-clear-button {
    margin-right: 4px;
    padding: 4px;
    border-radius: 50%;
    background: transparent;
    border: none;
    cursor: pointer;
}

.select-clear-button:hover {
    background-color: #f3f4f6;
}

.select-icon {
    width: 16px;
    height: 16px;
    color: #6b7280;
}

.select-icon-rotate {
    transform: rotate(180deg);
    transition: transform 0.2s ease;
}

/* Error Message */
.select-error-message {
    margin-top: 4px;
    font-size: 14px;
    color: #ef4444;
}

/* Dropdown Menu */
.select-menu {
    position: absolute;
    z-index: 9999;
    margin-bottom: 4px;
    max-height: 240px;
    width: 100%;
    overflow: auto;
    border-radius: 8px;
    border: 1px solid #d1d5db;
    background-color: white;
    padding: 4px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    font-weight: 400;
    font-size: 14px;
    margin-top: 0;
}

/* Options */
.select-option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 8px;
    cursor: pointer;
    color: #6b7280;
}

.select-option:hover {
    background-color: #f3f4f6;
    border-radius: 8px;
    color: #344767;
    font-weight: 400;

}

.select-option-selected {
    background-color: #f3f4f9;
    border-radius: 8px;
    color: #344767;
}

.select-option-highlighted {
    background-color: #f9fafb;
    border-radius: 8px;
}

.select-option-disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.select-check-icon {
    width: 16px;
    height: 16px;
    color: #4b5563;
}

.select-no-options {
    padding: 6px 8px;
    font-size: 14px;
    color: #6b7280;
}

`, "",{"version":3,"sources":["webpack://./src/reusableComponents/Select/CustomSelect.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,iCAAiC;AACjC;IACI,SAAO;IACP,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,YAAY;IACZ,iFAAiF;IACjF,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB","sourcesContent":["/* Select Container */\n.select-container {\n    position: relative;\n    width: 280px;\n}\n\n.select-full-width {\n    width: 100%;\n}\n\n.select-disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* Select Trigger */\n.select-trigger {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 40px;\n    padding: 0 12px;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.select-outlined {\n    border: 1px solid #d1d5db;\n    background-color: white;\n}\n\n.select-outlined:hover {\n    border-color: #9ca3af;\n}\n\n.select-filled {\n    background-color: #f3f4f6;\n}\n\n.select-filled:hover {\n    background-color: #e5e7eb;\n}\n\n.select-standard {\n    border-bottom: 1px solid #d1d5db;\n    background-color: transparent;\n}\n\n.select-standard:hover {\n    border-color: #9ca3af;\n}\n\n.select-error {\n    border-color: #ef4444 !important;\n}\n\n.select-trigger-disabled {\n    cursor: not-allowed;\n}\n\n/* Select Value and Placeholder */\n.select-value {\n    flex: 1;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 14px;\n    font-weight: 400;\n    color: #344767;\n}\n\n.select-placeholder {\n    color: #6b7280;\n}\n\n/* Select Actions */\n.select-actions {\n    display: flex;\n    align-items: center;\n}\n\n.select-clear-button {\n    margin-right: 4px;\n    padding: 4px;\n    border-radius: 50%;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n}\n\n.select-clear-button:hover {\n    background-color: #f3f4f6;\n}\n\n.select-icon {\n    width: 16px;\n    height: 16px;\n    color: #6b7280;\n}\n\n.select-icon-rotate {\n    transform: rotate(180deg);\n    transition: transform 0.2s ease;\n}\n\n/* Error Message */\n.select-error-message {\n    margin-top: 4px;\n    font-size: 14px;\n    color: #ef4444;\n}\n\n/* Dropdown Menu */\n.select-menu {\n    position: absolute;\n    z-index: 9999;\n    margin-bottom: 4px;\n    max-height: 240px;\n    width: 100%;\n    overflow: auto;\n    border-radius: 8px;\n    border: 1px solid #d1d5db;\n    background-color: white;\n    padding: 4px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n    font-weight: 400;\n    font-size: 14px;\n    margin-top: 0;\n}\n\n/* Options */\n.select-option {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 6px 8px;\n    cursor: pointer;\n    color: #6b7280;\n}\n\n.select-option:hover {\n    background-color: #f3f4f6;\n    border-radius: 8px;\n    color: #344767;\n    font-weight: 400;\n\n}\n\n.select-option-selected {\n    background-color: #f3f4f9;\n    border-radius: 8px;\n    color: #344767;\n}\n\n.select-option-highlighted {\n    background-color: #f9fafb;\n    border-radius: 8px;\n}\n\n.select-option-disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.select-check-icon {\n    width: 16px;\n    height: 16px;\n    color: #4b5563;\n}\n\n.select-no-options {\n    padding: 6px 8px;\n    font-size: 14px;\n    color: #6b7280;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
